import React from 'react';

import viewIcon from 'images/icons/invite/view.svg';
import downloadIcon from 'images/icons/invite/download.svg';
import deleteIcon from 'images/icons/invite/delete.svg';

import Tooltip from 'components/ui/Tooltip';

export default function RowActions({ row, onDelete }) {
  const onDeleteClick = (e, row) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this report?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          onDelete(row.id);
        }
      },
    );
  };

  return (
    <div>
      {row.attributes.type_report === '' && (
        <>
          <a
            data-tip="View"
            target="_blank"
            href={`/reports/report_preview?report_content_id=${row.id}`}
            className="mr10"
            rel="noreferrer"
          >
            <img src={viewIcon} alt="edit" />
          </a>
          <a
            data-tip="Download"
            target="_blank"
            href={`/reports/report_preview.pdf?report_content_id=${row.id}`}
            className="mr10"
            rel="noreferrer"
          >
            <img src={downloadIcon} alt="edit" />
          </a>
        </>
      )}

      {row.attributes.type_report === 'attachment' && (
      <a
        data-tip="Download"
        target="_blank"
        href={row.attributes.report_url}
        className="mr10"
        rel="noreferrer"
      >
        <img src={downloadIcon} alt="edit" />
      </a>
      )}

      <a data-tip="Delete" onClick={(e) => onDeleteClick(e, row)}>
        <img src={deleteIcon} />
      </a>
      <Tooltip />
    </div>
  );
}
